import React from "react";
import cropr, { GeometryModel } from "../shared/utils/cropr";
import gettext from "../shared/utils/gettext";

export type LinksType = {
  id: number;
  plan?: number;
};
export type LinkFieldProps = {
  records?: LinksType[];
  cropfields?: LinksType[];
  parcels?: LinksType[];
  machines?: LinksType[];
  farms?: LinksType[];
  users?: LinksType[];
};
const getCropField = (cfId: number): GeometryModel | undefined =>
  cropr.cropfields.models.find((m) => m.get("id") === cfId);
const getParcel = (pId: number) => cropr.parcels.models.find((m) => m.get("id") === pId);
const getRecord = (rId: number) => cropr.records.models.find((m) => m.get("id") === rId);
const getPlan = (pId: number) => cropr.plans.models.find((m) => m.get("id") === pId);
const getMachine = (pId: number) => cropr.machines.models.find((m) => m.get("id") === pId);
const getFarm = (pId: number) => cropr.farm;
const getUser = (pId: number) => cropr.user;
const getHyperlink = (key: keyof LinkFieldProps, id: number) => {
  if (key === "records") return `/cropr/record/record/#edit/${id}`;
  if (key === "cropfields")
    return `/cropr/dashboard/#cropfield/${getCropField(id)?.get("crop") || "0"}/${id}/`;
  if (key === "parcels") return `/cropr/farm/plan/#parcel/${id}/edit`;
  if (key === "machines") return `/cropr/machines/`;
  if (key === "farms") return `/cropr/settings/farm/`;
  if (key === "users") return `/cropr/settings/profile/`;
};

const linksTypeLookup = {
  records: { text: gettext("Record"), get: getRecord },
  cropfields: { text: gettext("Cropfield"), get: getCropField },
  parcels: { text: gettext("Parcel"), get: getParcel },
  machines: { text: gettext("Machine"), get: getMachine },
  farms: { text: gettext("Farm"), get: getFarm },
  users: { text: gettext("User"), get: getUser },
};
const getHyperlinkText = (key: keyof LinkFieldProps, id: number) => {
  const linkType = linksTypeLookup[key];
  const text = `${linkType.text} `;
  const obj = linkType.get(id);
  if (key === "records") return text + `${obj?.get("id") || gettext("Unknown")}`;
  return text + `${(obj?.get && obj?.get("name")) || obj?.name || gettext("Unknown")}`;
};
const LinkedFields = (props: LinkFieldProps) => {
  return (
    <div className="text-muted" style={{ fontSize: "0.6rem" }}>
      {(Object.keys(props) as Array<keyof LinkFieldProps>).map(
        (linktypeKey: keyof LinkFieldProps) =>
          props[linktypeKey]?.map((lt: LinksType, i: number) => (
            <React.Fragment key={i}>
              {lt.plan && lt.plan !== cropr.mainplan.id ? (
                // Linked to record/field not in current plan. Print a text only
                `${linksTypeLookup[linktypeKey].text} ${gettext("in plan")} ${
                  (lt.plan && getPlan(lt.plan)?.get("name")) || gettext("Unknown")
                }`
              ) : (
                // Linked to field in current plan. Show a hyperlink to open the field/record.
                <a
                  className="mr-1"
                  key={i}
                  href={getHyperlink(linktypeKey, lt.id)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {getHyperlinkText(linktypeKey, lt.id)}
                </a>
              )}
              <br />
            </React.Fragment>
          ))
      )}
    </div>
  );
};

export default LinkedFields;
